import { Link } from "react-router-dom";
import { ExternalLink } from "lucide-react";
import { StatusBadge } from "@/components/shared/StatusBadge";
import type { EdcRecord } from "@/api/types";

export function SubjectInspector({ data }: { data: unknown }) {
  const subject = data as EdcRecord;

  return (
    <div className="space-y-6">
      <Link
        to={`/studies/${subject.studyId}/subjects/${subject.id}`}
        className="inline-flex items-center gap-1 text-xs font-medium text-primary hover:text-primary/80"
      >
        <ExternalLink className="h-3 w-3" /> View Full Details
      </Link>
      <div>
        <h3 className="text-lg font-semibold text-foreground">{subject.label}</h3>
        <p className="mt-0.5 text-sm text-muted-foreground">{subject.edcSubjectId}</p>
        <div className="mt-2">
          <StatusBadge status={subject.status} />
        </div>
      </div>

      <div className="space-y-2">
        <Detail label="EDC System" value={subject.edcSystem} />
        <Detail label="Study" value={subject.edcStudyId} />
        {subject.edcSiteId && <Detail label="Site" value={subject.edcSiteId} />}
      </div>

      {subject.data && Object.keys(subject.data).length > 0 && (
        <div>
          <h4 className="mb-2 text-xs font-medium uppercase tracking-wider text-muted-foreground">
            Data Fields
          </h4>
          <div className="rounded-lg border border-border divide-y divide-border">
            {Object.entries(subject.data).map(([key, value]) => (
              <div key={key} className="flex justify-between gap-4 px-3 py-2">
                <span className="text-xs font-medium text-muted-foreground truncate">{key}</span>
                <span className="text-xs text-foreground text-right truncate">
                  {value === null || value === undefined ? "—" : String(value)}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

function Detail({ label, value }: { label: string; value: string }) {
  return (
    <div>
      <span className="text-xs font-medium text-muted-foreground">{label}</span>
      <p className="text-sm text-foreground">{value}</p>
    </div>
  );
}
